/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { FlatTaskEvaluationInput } from './flatTaskEvaluationInput';
import type { OralExamTaskEvaluationInput } from './oralExamTaskEvaluationInput';

export type TaskEvaluationRequestEvaluationAnyOf = FlatTaskEvaluationInput | OralExamTaskEvaluationInput;
